module.exports = __webpack_public_path__ + "static/media/sms.42c1b3af.svg";